// extracted by mini-css-extract-plugin
export default {"background":"Background_background__syS0M","blur":"Background_blur__Wmrfq"};